/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoSlackIcon16Solid = forwardRef('LogoSlackIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4 2.5A1.5 1.5 0 0 0 5.5 4h1.167C6.85 4 7 3.85 7 3.667V2.5a1.5 1.5 0 1 0-3 0Z" }),
        React.createElement("path", { d: "M9.5 1A1.5 1.5 0 0 0 8 2.5v3a1.5 1.5 0 1 0 3 0v-3A1.5 1.5 0 0 0 9.5 1Z" }),
        React.createElement("path", { d: "M13.5 4A1.5 1.5 0 0 0 12 5.5v1.167c0 .184.15.333.333.333H13.5a1.5 1.5 0 0 0 0-3Z" }),
        React.createElement("path", { d: "M2.5 8a1.5 1.5 0 1 1 0-3h3a1.5 1.5 0 1 1 0 3h-3Z" }),
        React.createElement("path", { d: "M8 13.5a1.5 1.5 0 0 1-3 0v-3a1.5 1.5 0 1 1 3 0v3Z" }),
        React.createElement("path", { d: "M2.5 12A1.5 1.5 0 0 0 4 10.5V9.333A.333.333 0 0 0 3.667 9H2.5a1.5 1.5 0 1 0 0 3Z" }),
        React.createElement("path", { d: "M13.5 8a1.5 1.5 0 0 1 0 3h-3a1.5 1.5 0 0 1 0-3h3Z" }),
        React.createElement("path", { d: "M12 13.5a1.5 1.5 0 0 0-1.5-1.5H9.333a.333.333 0 0 0-.333.333V13.5a1.5 1.5 0 0 0 3 0Z" })));
});
